import { useState } from "react";
import Title from "../Title";
import Book from "./Book";



const NewBooks = () => {
    const [openTab, setOpenTab] = useState("farsi");

    const tabHandler = (type) => {
        setOpenTab(type);
    };

    const bookList = {
        farsi: {
            type: "کتب فارسی",
            books: [
                { title: "کلاس تشریح دکتر لوپ", author: "نینا سیگل", year: "1380", img: "1.jpg" },
                { title: "زندگی خود را دوباره بیافرین", author: "جفری یانگ", year: "1379", img: "2.jpg" },
                { title: "هردو در نهایت", author: "آدام سیلوا", year: "1386", img: "3.jpg" },
                { title: "نیمه شب", author: "مت هیگ", year: "1392", img: "4.jpg" },
            ],
        },
        eslami: {
            type: "کتب اسلامی",
            books: [
                { title: "2کلاس تشریح دکتر لوپ", author: "2نینا سیگل", year: "1380", img: "1.jpg" },
                { title: "2زندگی خود را دوباره بیافرین", author: "2جفری یانگ", year: "1379", img: "2.jpg" },
                { title: "2هردو در نهایت", author: "2آدام سیلوا", year: "1386", img: "3.jpg" },
                { title: "2نیمه شب", author: "2مت هیگ", year: "1392", img: "4.jpg" },
            ],
        },
        payanname: {
            type: "پایان نامه",
            books: [
                { title: "3کلاس تشریح دکتر لوپ", author: "3نینا سیگل", year: "1380", img: "1.jpg" },
                { title: "3زندگی خود را دوباره بیافرین", author: "3جفری یانگ", year: "1379", img: "2.jpg" },
                { title: "3هردو در نهایت", author: "3آدام سیلوا", year: "1386", img: "3.jpg" },
                { title: "3نیمه شب", author: "3مت هیگ", year: "1392", img: "4.jpg" },
            ],
        },
        nashrie: {
            type: "نشریات",
            books: [
                { title: "4کلاس تشریح دکتر لوپ", author: "4نینا سیگل", year: "1380", img: "1.jpg" },
                { title: "4زندگی خود را دوباره بیافرین", author: "4جفری یانگ", year: "1379", img: "2.jpg" },
                { title: "4هردو در نهایت", author: "4آدام سیلوا", year: "1386", img: "3.jpg" },
                { title: "4نیمه شب", author: "4مت هیگ", year: "1392", img: "4.jpg" },
            ],
        },
    };

    const booksType = Object.keys(bookList);

    const {books} = bookList[openTab]


    return (
        <section className="container pb-6  relative bottom-11 bg-slate-50">
            <Title width="full">تازه های کتابخانه</Title>
            <nav className="mx-16 my-4">
                <ul className="flex gap-3 text-slate-50">
                    {booksType.map((item) => (
                        <li
                            className={`py-2 px-5 rounded-lg cursor-pointer hover:bg-sky-600 
                                        ${openTab === item ? "bg-sky-600" : "bg-sky-900"}`}
                            onClick={() => tabHandler(item)}
                            key={item}
                        >
                            {bookList[item].type}
                        </li>
                    ))}
                </ul>
                <div className="books flex justify-center flex-wrap gap-4 m-8">
                    {books.map(book => (
                        <Book title={book.title} author={book.author} year={book.year} img={book.img} key={book.img} />
                    ))}
                </div>
            </nav>
        </section>
    );
};

export default NewBooks;
